import { useEffect } from 'react'
import { useParams } from 'react-router'
import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { contactsDetailsGlobalStore } from 'widgets/ContactsDetails/store'
import { useContactsPageContext } from 'pages/contacts/context/contactsPageContext'
import { ContactsRoutes } from '../type'

const parseContactId = (value?: string): number | null => {
  if (!value) return null

  const parsed = Number(value)

  return Number.isInteger(parsed) && parsed > 0 ? parsed : null
}

export const ContactProfileRoute = observer(() => {
  const contactsPageStore = useContactsPageContext()
  const { contactsTableStore } = contactsPageStore
  const { id } = useParams()
  const allPath = `/${ContactsRoutes.root}/${ContactsRoutes.all}`

  useEffect(() => {
    const parsed = parseContactId(id)

    if (parsed === null) {
      uiStore.changeRoute({ path: allPath, method: 'replace' })

      return
    }

    if (parsed === contactsTableStore.activeContact?.id) return

    let cancelled = false

    contactsPageStore.openContactById(parsed).then((opened) => {
      if (cancelled) return

      if (!opened) uiStore.changeRoute({ path: allPath, method: 'replace' })
    })

    return () => {
      cancelled = true
    }
  }, [id])

  useEffect(() => {
    return () => {
      contactsPageStore.setSuppressCloseNavigation(true)
      contactsTableStore.setActiveContact(null)
      contactsDetailsGlobalStore.handleChangeCollapse(true)
      contactsPageStore.setSuppressCloseNavigation(false)
    }
  }, [])

  return null
})
